import React from 'react';
import { useWigTransfer } from '../../contexts/WigTransferContext';
// import './TransferButton.css';

const TransferButton = ({ 
  orderNo, 
  variant = 'primary', 
  size = 'sm', 
  showText = true,
  className = '',
  disabled = false 
}) => {
  const { openTransferModal, transferData } = useWigTransfer();

  if (!orderNo) {
    return null;
  }

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled) {
      console.log('🔄 Transfer button clicked for order:', orderNo);
      openTransferModal(orderNo);
    }
  };

  const getButtonClass = () => {
    const baseClass = 'transfer-btn';
    const variantClass = `transfer-btn-${variant}`;
    const sizeClass = `transfer-btn-${size}`;
    
    return `${baseClass} ${variantClass} ${sizeClass} ${className} ${disabled ? 'disabled' : ''}`.trim();
  };

  const getIcon = () => {
    if (transferData.isLoading) {
      return <i className="fas fa-spinner fa-spin"></i>;
    }
    
    switch (variant) {
      case 'icon-only':
        return <i className="fas fa-exchange-alt"></i>;
      case 'success':
        return <i className="fas fa-share"></i>;
      case 'warning':
        return <i className="fas fa-exclamation-triangle"></i>;
      default:
        return <i className="fas fa-exchange-alt"></i>;
    }
  };

  const getText = () => {
    if (!showText || variant === 'icon-only') return '';
    
    if (transferData.isLoading) return 'Loading...';
    
    switch (variant) {
      case 'success':
        return 'Ready to Transfer';
      case 'warning':
        return 'Force Transfer';
      case 'outline':
        return 'Transfer';
      default:
        return 'Transfer Wig';
    }
  };

  return (
    <button
      className={getButtonClass()}
      onClick={handleClick}
      disabled={disabled || transferData.isLoading}
      title={`Transfer wig for order ${orderNo}`}
      aria-label={`Open transfer modal for order ${orderNo}`}
    >
      {getIcon()}
      {showText && <span className="ml-2">{getText()}</span>}
    </button>
  );
};

export default TransferButton;